import React from "react";
import { useCompanySettings } from "../hooks/useCompanySettings";
import i18n from "@euroland/libs/locale/i18n";
import { classNames } from "../utils";
import { useInstrument } from "../hooks/useInstruments";

export default function Footer() {
  const { showDataProviderInfo, showDataDelayInfo, showTermsOfService, showCookiePolicyInfo, showPrivacyPolicyInfo = true, instruments } =
    useCompanySettings();
  const [{ selectedInstrument: { isRT } }] = useInstrument();
  const { language, termsOfServiceURL, cookiePolicyURL, suppliedByLanguage, eurolandURL, privacyPolicyURL } =
    window.appSettings;
  const euroland = eurolandURL || "https://www.euroland.com/";
  const termsOfService = termsOfServiceURL || "https://tools.eurolandir.com/legal/terms/";
  const cookiePolicy = cookiePolicyURL || "https://tools.eurolandir.com/legal/cookie/";
  const privacyPolicy = privacyPolicyURL || "https://tools.eurolandir.com/legal/privacy/";
  const isRealtime = isRT ?? instruments.find(ins => ins.default)?.isRT ?? instruments[0]?.isRT;
  return (
    <footer
      className={classNames("footer", {
        "has-provider-info": showDataProviderInfo,
        "has-dataDelay-info": showDataDelayInfo,
        "has-terms-of-service": showTermsOfService,
        //"has-disclaimer-info": showTermsOfService,
      })}
      dir={window.appSettings?.isRtl ? "rtl" : "ltr"}
    >
      <div className="footer-content">
        {showDataProviderInfo && (
          <p className="footer-content_primary">
            {i18n.translate("supplyBy")}
            <a
              target="_blank"
              rel="noreferrer"
              className="footer__supplierInfoLink"
              href={`${euroland}?SelectLanguage=${suppliedByLanguage || "english"}`}
            >
              {i18n.translate("euroland_com")}
            </a>
          </p>
        )}

        <div className="footer-content_secondary print-none">

          {showDataDelayInfo && !isRealtime && <p>{i18n.translate("dataDelay")}</p>}

          {(showTermsOfService || showCookiePolicyInfo || showCookiePolicyInfo) && (
            <p>
              {showTermsOfService && (
                <a href={`${termsOfService}?lang=${language}`} target="_blank" rel="noreferrer">
                  {i18n.translate("termsOfService")}
                </a>
              )}

              {showTermsOfService && showPrivacyPolicyInfo && <span> | </span>}

              {showPrivacyPolicyInfo && (
                <a href={`${privacyPolicy}?lang=${language}`} target="_blank" rel="noreferrer">
                  {i18n.translate("privacyPolicy")}
                </a>
              )}
              {showTermsOfService && !showPrivacyPolicyInfo && showCookiePolicyInfo && <span> | </span>}

              {showPrivacyPolicyInfo && showCookiePolicyInfo && <span> | </span>}
              {showCookiePolicyInfo && (
                <a href={`${cookiePolicy}?lang=${language}`} target="_blank" rel="noreferrer">
                  {i18n.translate("cookiePolicy")}
                </a>
              )}
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
